import { GalleryState } from '../../../components/gallery';
import { Resource } from '../../../types/game-document';
import { GameDocument } from '../../../types/game-document';
import { TaskContentForm } from '../../../types/game-document/entities/task-content';
import { isContentHtmlEmpty } from '../../game-engine/html-content';
import {
  GetResourceEntity,
  GetResourceValue,
  ResourceGetById
} from '../resources';

/**
 * Get task content by id from game document local storage.
 * @param gameDocument - The Game Document as datasource
 * @param taskContentId - The task content id you are looking for
 * @constructor
 */
export const GetTaskContentById = (
  gameDocument: GameDocument | undefined,
  taskContentId: string
) => {
  return gameDocument?.assets.taskContents?.find((x) => x.id === taskContentId);
};

export const GetCustomFeedback = (
  gameDocument: GameDocument | undefined,
  taskContentId: string,
  formIndex: number
) => {
  return gameDocument?.assets.taskContents?.find((x) => x.id === taskContentId)
    ?.forms![formIndex].customFeedback;
};

export const GetFormMedia = (
  gameDocument: GameDocument,
  form: TaskContentForm
) => {
  let galleryItems: GalleryState[] = [];

  if (form.medias) {
    for (const resourceId of form.medias) {
      let resource = ResourceGetById(gameDocument?.resources, resourceId);
      if (!resource) continue;

      galleryItems.push({
        id: resource.id,
        name: resource.name,
        fileType: resource.type,
        url:
          (resource.value as Blob | string) instanceof Blob
            ? URL.createObjectURL(resource.value as unknown as Blob)
            : resource.value
      });
    }
  }
  return galleryItems;
};

export const GetQuestionsFromTaskContent = (
  gameDocument: GameDocument,
  id: string
) => {
  let forms = gameDocument?.assets?.taskContents?.find(
    (x) => x.id === id
  )?.forms;

  if (forms) {
    let extractedData = forms?.map(({ id, questionResId }) => ({
      id,
      description: GetResourceValue(gameDocument, questionResId!, '')
    }));

    return extractedData;
  }
  return [];
};

export const GetForm = (
  gameDocument: GameDocument,
  taskContentid: string,
  formId: string
) => {
  let form = gameDocument?.assets?.taskContents
    ?.find((x) => x.id === taskContentid)
    ?.forms?.find((x) => x.id === formId);

  return form ?? undefined;
};

export const isContainPremessageOrIntro = (
  gameDocument: GameDocument,
  taskContentId: string,
  language?: string
) => {
  const taskContent = gameDocument.assets?.taskContents?.find(
    (x) => x.id === taskContentId
  );

  let premessage = false;
  let premessageContent = '';
  let premessageBlobs: Resource['embeddedBlobs'] = [];
  let intro = false;
  let introContent = '';
  let introBlobs: Resource['embeddedBlobs'] = [];

  if (taskContent) {
    if (taskContent.preMessageResId) {
      const premessageEntity = GetResourceEntity(
        gameDocument,
        taskContent.preMessageResId,
        language
      );
      const content = premessageEntity?.value ?? '';
      premessage = !isContentHtmlEmpty(content);
      premessageContent = content;
      if (premessageEntity?.embeddedBlobs)
        premessageBlobs = premessageEntity.embeddedBlobs;
    }

    if (taskContent.contentResId) {
      const introEntity = GetResourceEntity(
        gameDocument,
        taskContent.contentResId,
        language
      );
      const content = introEntity?.value ?? '';
      intro = !isContentHtmlEmpty(content);
      introContent = content;
      if (introEntity?.embeddedBlobs) introBlobs = introEntity.embeddedBlobs;
    }
  }

  return {
    premessage,
    premessageContent,
    premessageBlobs,
    intro,
    introContent,
    introBlobs
  };
};
